/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    NftPurchaseCartItem,
    NftPurchaseCartItemFromJSON,
    NftPurchaseCartItemFromJSONTyped,
    NftPurchaseCartItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface NftPurchaseRequestBody
 */
export interface NftPurchaseRequestBody {
    /**
     * 
     * @type {number}
     * @memberof NftPurchaseRequestBody
     */
    fiatInDpay?: number;
    /**
     * 
     * @type {string}
     * @memberof NftPurchaseRequestBody
     */
    paymentMethodId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NftPurchaseRequestBody
     */
    isCoinbase?: boolean;
    /**
     * 
     * @type {Array<NftPurchaseCartItem>}
     * @memberof NftPurchaseRequestBody
     */
    cartItems?: Array<NftPurchaseCartItem>;
}

export function NftPurchaseRequestBodyFromJSON(json: any): NftPurchaseRequestBody {
    return NftPurchaseRequestBodyFromJSONTyped(json, false);
}

export function NftPurchaseRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): NftPurchaseRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fiatInDpay': !exists(json, 'fiatInDpay') ? undefined : json['fiatInDpay'],
        'paymentMethodId': !exists(json, 'paymentMethodId') ? undefined : json['paymentMethodId'],
        'isCoinbase': !exists(json, 'isCoinbase') ? undefined : json['isCoinbase'],
        'cartItems': !exists(json, 'cartItems') ? undefined : ((json['cartItems'] as Array<any>).map(NftPurchaseCartItemFromJSON)),
    };
}

export function NftPurchaseRequestBodyToJSON(value?: NftPurchaseRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fiatInDpay': value.fiatInDpay,
        'paymentMethodId': value.paymentMethodId,
        'isCoinbase': value.isCoinbase,
        'cartItems': value.cartItems === undefined ? undefined : ((value.cartItems as Array<any>).map(NftPurchaseCartItemToJSON)),
    };
}


